import React, { useState } from 'react'
import GenericIcon from 'components/GenericIcon'

const FAQCollapse = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const Plus =  <GenericIcon className='generic-icon' name='plusIcon' />;
  const Minus =  <GenericIcon className='generic-icon' name='minusIcon' />;
  const icon = collapsed ? Plus : Minus;

  const handleClick = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`faq-container ${!collapsed && 'expanded'} mb-3 pt-3 pb-3`}>
      <div className="bigger faq-header" onClick={handleClick} >
        <span className='faq-title'>
          {props.title}
        </span>

        <div id='plus-minus-icon' onClick={handleClick} >
          {icon}
        </div>
      </div>

      <div className="faq-content">
        {props.content}
      </div>
    </div>
  );
};

export default FAQCollapse;
